import Vue from 'vue'
import Router from 'vue-router'
import { ROUTE_META } from '../lib/const';
import config from '../lib/config';
import routes from './route.js';
import event from '../lib/event';
import userService from '../lib/UserService';

Vue.use(Router);

function clone(a){
    return Object.assign({},a);
}
const router = new Router({
    base:config.publicPath||"",
    mode: 'history',
    routes:routes.map((a)=>{
        a.meta = a.meta || {};
        var b = clone(ROUTE_META);
        Object.assign(b,a.meta);
        Object.assign(a.meta,b);
        return a;
    })
});

global.$router = router;
$router._go = $router.push;
$router.go = function (arg,forceRefresh) {
    console.log('Router.go',arg);
    if(forceRefresh){
        global.location.href = arg;
        return;
    }
    if(typeof arg == 'string'){
        if( /^\/[^\/].*$|^\/$/.test(arg) ){ // internal url, start with `/` but not `//`
            return this._go(arg);
        }else{
            global.location.href = arg;
        }
    }else{
        return this._go(arg);
    }
}

var defaultTitle = '';
if(global.window){
    defaultTitle = global.document.title;
}
router.beforeEach((to,from,next)=>{
    console.log('ROUTE_CHANGE',to.path,to,from);
    var meta = to.meta;

    event.emit('route_change_start',to);


    function changeTitle(title) {
        document.title = title || defaultTitle;
    }
    changeTitle(meta.title);
    console.log(meta.title);
    //
    // setTimeout(()=>{
    //     $('<iframe src="/favicon.ico" style="display: none"></iframe>').one('load', function() {
    //         setTimeout(() => {
    //             $(this).remove()
    //         }, 0)
    //     }).appendTo('body');
    // },100);

    let code = to.query.code;

    function doSomethingInit() {
        if(meta.auth && ! userService.isLogined()){
            // transition.abort();
            userService.goToLoginPage(to.fullPath,code);
            return;
        }
        next();
    }


    if(to.name==='login'){
        doSomethingInit();
    }else{
        userService.init().then(doSomethingInit);
    }
});

module.exports = router;



// WEBPACK FOOTER //
// src/router/index.js